import { render, staticRenderFns } from "./partnerWise.vue?vue&type=template&id=fc355dbc&scoped=true"
import script from "./partnerWise.vue?vue&type=script&lang=js"
export * from "./partnerWise.vue?vue&type=script&lang=js"
import style0 from "./partnerWise.vue?vue&type=style&index=0&id=fc355dbc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc355dbc",
  null
  
)

export default component.exports